import SectionContainer from "~/components/SectionContainer";

const REASONS = [
	{
		title: "Unrivaled accuracy.",
		body: "Every course is built on a comprehensive review of the peer-reviewed research. Our learners get the most precise, current information in the industry — and it shows in what they can do for clients.",
	},
	{
		title: "Built for how people actually learn.",
		body: "Short courses, a small exam after each one, and a credit system that replaces the single high-stakes final. Video, illustration, audio, and text, on desktop and mobile, so you can study anywhere, any time.",
	},
	{
		title: "Affordable and accessible.",
		body: "A flexible monthly membership (cancel anytime) at a cost similar to a streaming subscription — instead of a large, one-time purchase before you know whether the education is any good.",
	},
] as const;

const CptWhyBrookbush = () => {
	return (
		<SectionContainer className="flex max-w-4xl flex-col gap-8 border-b">
			<h2 className="text-center font-bold text-2xl sm:text-3xl lg:text-4xl">
				Why the Brookbush Institute
			</h2>
			<div className="flex flex-col gap-6">
				{REASONS.map((reason) => (
					<div key={reason.title} className="flex flex-col gap-2">
						<h3 className="font-semibold text-xl sm:text-2xl">
							{reason.title}
						</h3>
						<p className="text-base sm:text-lg">{reason.body}</p>
					</div>
				))}
			</div>
		</SectionContainer>
	);
};

export default CptWhyBrookbush;
